<template>
    <q-dialog ref="dialog" @hide="onDialogHide" persistent>
        <q-card class="q-dialog-plugin " style="width: 30vw; max-width: 90vw;">
            <q-toolbar class="bg-primary text-white">
                <q-toolbar-title v-text="(actionTitle + ' ' + screenTitle).trim()"></q-toolbar-title>
                <q-btn flat round dense icon="close" v-close-popup></q-btn>
            </q-toolbar>

            <q-form ref="modelForm">
                <q-card-section>
                    <div class="flex column wrap">
                        <div class="row q-col-gutter-lg">
                            <div class="col-12" >
                            <q-input v-model="model.Name" type="text" 
                                     label="User Name" 
                                      
                                      
                                      readonly
                                     :rules="[]"
                                     :error="fieldHasError('Name')"
                                     :error-message="fieldErrorMessage('Name')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.GivenName" type="text" 
                                     label="Given Name" 
                                      
                                      
                                      :readonly="model.IsFederated"
                                     :rules="[]"
                                     :error="fieldHasError('GivenName')"
                                     :error-message="fieldErrorMessage('GivenName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>
<div class="col-12" >
                            <q-input v-model="model.FamilyName" type="text" 
                                     label="Family Name" 
                                      
                                      
                                      :readonly="model.IsFederated"
                                     :rules="[]"
                                     :error="fieldHasError('FamilyName')"
                                     :error-message="fieldErrorMessage('FamilyName')"
                                     
                                     
                                     dense>
                                
                                
                                
                            </q-input>
                        </div>

                        </div>
                    </div>
                </q-card-section>
            </q-form>

            <q-toolbar>
                <div class="q-gutter-xs">
                    
                </div>

                <q-space></q-space>

                <div class="q-gutter-xs" v-if="editMode === true">
                    
                    <q-btn color="primary" :label="actionLabel" @click="onOkClick" :disable="actionLocked"></q-btn>
                    <q-btn color="white" text-color="black" label="Cancel" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
                <div class="q-gutter-xs" v-if="editMode === false">
                    
                    <q-btn color="white" text-color="black" label="Close" @click="onCancelClick" :disable="actionLocked"></q-btn>
                </div>
            </q-toolbar>

            <q-inner-loading :showing="loading">
                <q-spinner-gears size="50px" color="primary"></q-spinner-gears>
            </q-inner-loading>
        </q-card>
    </q-dialog>
</template>

<style>
    
</style>

<script>
    export { default } from './currentusereditmodel-dialog-screen.js'
</script>